export default "__VITE_ASSET__CFgp8K1j__"